module.exports = __webpack_public_path__ + "img/dots_rtb1.02a05335.png";